"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var CardHeader_1 = __importDefault(require("@material-ui/core/CardHeader"));
var CardHeader = function (_a) {
    var classes = _a.classes, _b = _a.component, component = _b === void 0 ? 'div' : _b, action = _a.action, avatar = _a.avatar, _c = _a.disableTypography, disableTypography = _c === void 0 ? false : _c, subheader = _a.subheader, subheaderTypographyProps = _a.subheaderTypographyProps, title = _a.title, titleTypographyProps = _a.titleTypographyProps;
    return (react_1.default.createElement(CardHeader_1.default, { classes: classes, component: component, action: action, avatar: avatar, disableTypography: disableTypography, subheader: subheader, subheaderTypographyProps: subheaderTypographyProps, title: title, titleTypographyProps: titleTypographyProps }));
};
exports.default = CardHeader;
